export interface ISearchResult {
    id: number;
    name: string;
    type: ISearchResultType;
    index: number;
}

export enum ISearchResultType {
    Organisation,
    Clinic,
    User
}